import React from "react";
import { Spinner } from "reactstrap";
import "./PageLoader.css";

/**
 * Shared loading indicator — use for page/section loading states.
 *
 * @param {"sm"|"default"} [size]
 * @param {string} [label] — sr-only accessibility label
 * @param {boolean} [inline] — inline in tables, cards, or compact areas
 * @param {boolean} [centered] — center in a section (default when not inline)
 * @param {string} [className]
 */
export default function PageLoader({
  size = "default",
  label = "Loading",
  inline = false,
  centered = true,
  className = "",
}) {
  const rootClass = [
    "lt-page-loader",
    inline && "lt-page-loader--inline",
    centered && !inline && "lt-page-loader--centered",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass} role="status" aria-live="polite" aria-busy="true">
      <Spinner color="primary" size={size === "sm" ? "sm" : undefined} />
      {label ? <span className="visually-hidden">{label}</span> : null}
    </div>
  );
}
